module.exports = __webpack_public_path__ + "img/icon_map_xmsh_c.bd4810b7.png";